import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import OnboardingComponent from "ui/organizms/Onboarding";

const Onboarding = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Onboarding'
    >
        <OnboardingComponent />
    </Screen>
);

export default memo(Onboarding);
